var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.loading)?_c('loader'):_vm._e(),_c('MusicBanner',{attrs:{"homeSlider":_vm.home_slider}}),_c('MusicCategory',{attrs:{"musiccategory":_vm.music_category}}),_c('TopSongs',{attrs:{"topSongs":_vm.top_songs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }